<template>
  <div class="grid-table" :class="mode">
    <Grid class="grid-table__columns" :gtc="gridTemplateColumns" align-items="center">
      <div
        v-for="(column, index) of columns"
        :key="column.label + index"
        class="grid-table__column q-pa-sm"
        :class="[`text-${column.align || 'left'}`, columnClassesByMode]"
      >
        {{ column.label }}
      </div>
    </Grid>

    <div class="grid-table__rows overflow-auto">
      <template v-if="rows">
        <Grid v-for="row of rows" :key="row.id" :gtc="gridTemplateColumns" align-items="center" class="grid-table__row">
          <slot name="row" :row="row"></slot>
        </Grid>

        <Grid v-if="!rows.length" align-items="center" class="grid-table__row">
          <GridTableCell full-row class="text-center" no-tooltip>
            <span class="text-caption-3 text-grey1">No rows to show</span>
          </GridTableCell>
        </Grid>
      </template>

      <Grid v-else align-items="center" class="grid-table__row">
        <GridTableCell full-row class="text-center" no-tooltip>
          <span class="text-subtitle-1">Loading rows...</span>
        </GridTableCell>
      </Grid>
    </div>
  </div>
</template>

<script>
// Components
import GridTableCell from './GridTableCell'

export default {
  components: {
    GridTableCell
  },

  props: {
    columns: Array,
    rows: Array,
    mode: {
      type: String,
      default: 'light',
      validator: val => ['light', 'ag-grid'].includes(val)
    }
  },

  computed: {
    gridTemplateColumns() {
      const gtcArray = this.columns.reduce((acc, curr) => {
        acc.push(`${curr.width ?? 'auto'}`)

        return acc
      }, [])

      return gtcArray.join(' ')
    },

    columnClassesByMode() {
      if (this.mode === 'light') return 'text-overline-1 bg-white-1 text-grey3'
      return 'text-body-4 text-secondary-5 bg-white-2 grid content-center'
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-table {
  --rows-max-h: calc(var(--row-h) * 5.5);

  &.light {
    --column-h: 48px;
    --row-h: 51px;

    .grid-table__column {
      line-height: var(--column-h);
    }
  }

  &.ag-grid {
    --column-h: 51px;
    --row-h: 68px;
  }

  &__columns {
    z-index: 1;
  }

  &__rows {
    max-height: var(--rows-max-h);
  }

  &__column {
    height: var(--column-h);
    border-bottom: 1px solid var(--r-white-5);
  }

  &__row {
    height: var(--row-h);
    line-height: var(--row-h);
    border-bottom: 1px solid var(--r-white-4);

    &:hover {
      background: var(--r-white-2);
    }
  }
}
</style>
